import React from "react";
import Modal from "react-modal";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import st from "./videoCover.module.scss";

type Props = {
  imageUrl: string;
  embedVideoUrl: string;
  isVideoModalOpen: boolean;
  openVideoModal: () => void;
  closeVideoModal: () => void;
};

const VideoCover = (props: Props) => {
  return (
    <>
      <div
        className={st.videoResponsive}
        style={{ backgroundImage: `url(${props.imageUrl})` }}
      >
        <div className={st.shadow}>
          <div className={st.circleWrapper} onClick={props.openVideoModal}>
            <div className={st.bigCircle} />
            <div className={st.smallCircle}>
              <div className={st.playButton} />
            </div>
          </div>
        </div>
      </div>
      <Modal
        onAfterClose={clearAllBodyScrollLocks}
        // Still need to check ref because the ref returns null while modal is closing.
        overlayRef={(ref) => {
          ref &&
            disableBodyScroll(document.body, { reserveScrollBarGap: true });
        }}
        isOpen={props.isVideoModalOpen}
        htmlOpenClassName="content-widget"
        onRequestClose={props.closeVideoModal}
        className={st.modal}
        overlayClassName={st.overlay}
        closeTimeoutMS={250}
        ariaHideApp={false}
        overlayElement={(props, content) => (
          <div {...props} className={st.overlay}>
            {content}
            <div className={st.closePlayerContainer}>
              <span className={st.closePlayerText}>CLOSE </span>
              <div className={st.close} />
            </div>
          </div>
        )}
      >
        <div
          id="youtube-container"
          className="content-widget"
          style={{ height: "100%" }}
        >
          <iframe
            className={st.iframeStyle}
            src={props.embedVideoUrl}
            title="YouTube video player"
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </Modal>
    </>
  );
};

export default VideoCover;
